import React, { useEffect, useState } from "react";
import {
  Content,
  Row,
  Col,
  Box,
  Button,
  Inputs,
  SimpleTable,
  Pagination,
} from "adminlte-2-react";
import _ from "lodash";
import controller from "./duck";
import { useSelector, useDispatch } from "react-redux";
import Loader from "../utils/Loader";
import SelectInput from "../utils/SelectInput";

const { Text } = Inputs;

function LocalesList({ history, match, test }) {
  const dispatch = useDispatch();

  const modelLocales = useSelector((state) => state.getLocales);
  const modelCategorias = useSelector((state) => state.categoriasForSelect);

  const [locales, setLocales] = useState(null);
  const [totalResults, setTotalResults] = useState(0);
  const [activePage, setActivePage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [nombre, setNombre] = useState("");
  const [categoria, setCategoria] = useState(null);
  const [categoriasOptions, setCategoriasOptions] = useState([]);

  useEffect(() => {
    const data = modelCategorias?.data?.data?.data;
    const error = modelCategorias?.error?.response?.data?.mensaje;

    if (error) {
      alert(error);
      dispatch(controller.duckCategoriasForSelect.actions.clear());
    }
    if (data) {
      setCategoriasOptions(data.lista);

      dispatch(controller.duckCategoriasForSelect.actions.clear());
    }
  }, [modelCategorias]);

  useEffect(() => {
    const data = modelLocales?.data?.data;
    const error = modelLocales?.error?.response?.data?.mensaje;

    if (error) {
      alert(error);
      dispatch(controller.duckGetLocales.actions.clear());
    }
    if (data) {
      setLocales(data.data.items);
      setTotalResults(data.data.total);

      dispatch(controller.duckGetLocales.actions.clear());
    }
  }, [modelLocales]);

  useEffect(() => {
    if (
      localStorage.getItem("localSelected") &&
      localStorage.getItem("categoriaSelected")
    ) {
      localStorage.removeItem("localSelected");
      localStorage.removeItem("categoriaSelected");
      return window.location.reload();
    }
    dispatch(controller.categoriasForSelectThunk());
    dispatch(controller.getLocalesThunk(1, pageSize, null, nombre, categoria));
  }, []);

  function handlePage(page) {
    setActivePage(page);
    setLocales([]);
    dispatch(
      controller.getLocalesThunk(page + 1, pageSize, null, nombre, categoria)
    );
  }

  return (
    <Content
      title="Locales"
      subTitle="Locales"
      browserTitle="Locales"
      show={false}
    >
      <Row>
        <Col md="10" mdOffset="1">
          <Box title="Locales">
            <Col md="12">
              <Col md="3">
                <SelectInput
                  value={categoria}
                  setValue={setCategoria}
                  label="Categoria"
                  options={categoriasOptions}
                />
              </Col>
              <Col md="3">
                <Text
                  labelPosition="above"
                  size="md"
                  label="Nombre del local"
                  value={nombre}
                  onChange={(evt) => setNombre(evt.target.value)}
                />
              </Col>

              <Col md="3">
                <div style={{ marginTop: 15 }}>
                  <Button
                    type="primary"
                    text="Filtrar"
                    onClick={() => handlePage(0)}
                  />
                </div>
              </Col>
            </Col>
            <Button
              type="primary"
              text="Agregar"
              pullRight={true}
              onClick={() => history.push("/nuevoLocal")}
            />
            <div>
              <span>Total: {totalResults}</span>
            </div>
            <Loader isLoading={modelLocales.loading}>
              {locales && locales.length > 0 ? (
                <SimpleTable
                  hover={true}
                  data={locales.map((row, index) => {
                    return {
                      nombre: row.nombre,
                      estado: row.estado,
                      categoria: row.categoriaNombre,
                      sucursales: row.sucursales ? "SI" : "NO",

                      detalles: !row.sucursales ? (
                        <Button
                          type="primary"
                          text="Detalles"
                          size="sm"
                          onClick={() => {
                            localStorage.setItem("localSelected", row._id);
                            localStorage.setItem(
                              "categoriaSelected",
                              row.categoria
                            );
                            window.location.href = "/calendarioLocal/"+row._id;
                          }}
                        />
                      ) : (
                        <Button
                          type="primary"
                          text="Detalles"
                          size="sm"
                          onClick={() => {
                            history.push(
                              `/sucursales/${row._id}/${row.categoria}`
                            );
                          }}
                        />
                      ),
                      editar: (
                        <Button
                          type="primary"
                          text="Editar"
                          size="sm"
                          onClick={() => history.push(`/editLocal/${row._id}`)}
                        />
                      ),
                    };
                  })}
                  columns={[
                    { title: "Nombre", data: "nombre" },
                    { title: "Categoria", data: "categoria" },
                    { title: "Estado", data: "estado" },
                    { title: "Tiene sucursales", data: "sucursales" },
                    { title: "Detalles", data: "detalles" },
                    { title: "Editar", data: "editar" },
                  ]}
                />
              ) : (
                <h4>No se han encontrado locales</h4>
              )}
            </Loader>
            <Pagination
              activePage={activePage}
              pageSize={pageSize}
              totalElements={totalResults}
              onChange={handlePage}
              labels={{
                first: "Primera",
                last: "Última",
                previous: "Anterior",
                next: "Siguiente",
              }}
            />
            <div>
              <span>Total: {totalResults}</span>
            </div>
          </Box>
        </Col>
      </Row>
    </Content>
  );
}

export default LocalesList;
